export const limits: { [key: string]: { min: number, max: number } } = {
    mealCount: {
        max: 3,
        min: 1,
    },
    fuelingCount: {
        max: 10,
        min: 1,
    }
}